// Auto-generated from Figma token exports.
// Structure: themes -> tokens -> css color value.
//
// To add a new theme:
//   1. Add a new key under `colors` below.
//   2. The `satisfies ThemePalette` clause forces you to provide every token
//      listed in `tokenNames`. Missing one is a compile error.
//   3. `ThemeName` updates automatically — no other edits needed.
//
// To add a new token:
//   1. Append it to `tokenNames` below.
//   2. Every existing theme will fail to compile until you add the value.

export const tokenNames = [
  "grey2",
  "grey3",
  "grey5",
  "grey10",
  "grey20",
  "grey30",
  "grey40",
  "grey50",
  "grey60",
  "grey70",
  "grey80",
  "grey100",
  "surfaceMinus1",
  "surface0",
  "surface1",
  "surfaceBlur",
  "surfaceStroke",
  "shadowColor",
  "primary",
  "onPrimary",
  "secondary",
  "onSecondary",
  "invert",
  "onInv100",
  "onInv80",
  "onInv60",
  "onInv40",
  "onInv20",
  "onInv10",
  "greenFill",
  "greenStroke",
  "greenText",
  "yellowFill",
  "yellowStroke",
  "yellowText",
  "redFill",
  "redStroke",
  "redText",
  "viz1",
  "viz1Light",
  "viz2",
  "viz2Light",
  "viz3",
  "viz3Light",
  "viz4",
  "viz4Light",
  "viz5",
  "viz5Light",
  "viz6",
  "viz6Light",
  "viz7",
  "viz7Light",
  "viz8",
  "viz8Light",
  "viz9",
  "viz9Light",
  "viz10",
  "viz10Light",
  "viz11",
  "viz11Light",
  "viz12",
  "viz12Light",
] as const;
export type TokenName = typeof tokenNames[number];

type ThemePalette = Record<TokenName, string>;

export const colors = {
  Frost: {
    grey2: "rgba(0, 19, 50, 0.02)",
    grey3: "rgba(0, 19, 50, 0.03)",
    grey5: "rgba(0, 19, 50, 0.05)",
    grey10: "rgba(1, 19, 49, 0.1)",
    grey20: "rgba(3, 20, 48, 0.2)",
    grey30: "rgba(4, 20, 46, 0.3)",
    grey40: "rgba(5, 20, 45, 0.4)",
    grey50: "rgba(6, 21, 44, 0.5)",
    grey60: "rgba(8, 21, 43, 0.6)",
    grey70: "rgba(9, 21, 41, 0.7)",
    grey80: "#0D1626",
    grey100: "#080C14",
    surfaceMinus1: "#F7F8F9",
    surface0: "#FFFFFF",
    surface1: "#FFFFFF",
    surfaceBlur: "#FFFFFF",
    surfaceStroke: "#FFFFFF",
    shadowColor: "rgba(0, 0, 0, 0.15)",
    primary: "#080C14",
    onPrimary: "#FFFFFF",
    secondary: "rgba(1, 19, 49, 0.1)",
    onSecondary: "#080C14",
    invert: "#1A1A1A",
    onInv100: "#FFFFFF",
    onInv80: "rgba(255, 255, 255, 0.8)",
    onInv60: "rgba(255, 255, 255, 0.6)",
    onInv40: "rgba(255, 255, 255, 0.4)",
    onInv20: "rgba(255, 255, 255, 0.2)",
    onInv10: "rgba(255, 255, 255, 0.1)",
    greenFill: "#57BE45",
    greenStroke: "rgba(87, 190, 69, 0.3)",
    greenText: "#157704",
    yellowFill: "#ECBB28",
    yellowStroke: "rgba(236, 187, 40, 0.4)",
    yellowText: "#997200",
    redFill: "#FF6A6A",
    redStroke: "rgba(255, 106, 106, 0.3)",
    redText: "#AE0B0B",
    viz1: "#7856FF",
    viz1Light: "#C5B7FF",
    viz2: "#FF7557",
    viz2Light: "#FFAB99",
    viz3: "#5DC2B9",
    viz3Light: "#96D9D3",
    viz4: "#F8BC3B",
    viz4Light: "#FACB68",
    viz5: "#B2596E",
    viz5Light: "#D5B0B8",
    viz6: "#95D3FF",
    viz6Light: "#95D3FF",
    viz7: "#FFB27A",
    viz7Light: "#FED1B1",
    viz8: "#0D7EA0",
    viz8Light: "#7BB3C3",
    viz9: "#3BA974",
    viz9Light: "#81D4AC",
    viz10: "#FEBBB2",
    viz10Light: "#F0B9B2",
    viz11: "#CA80DC",
    viz11Light: "#DAA6E6",
    viz12: "#5BB7AF",
    viz12Light: "#A4CECA",
  },
  Slate: {
    grey2: "rgba(255, 255, 255, 0.02)",
    grey3: "rgba(255, 255, 255, 0.03)",
    grey5: "rgba(255, 255, 255, 0.05)",
    grey10: "rgba(255, 255, 255, 0.1)",
    grey20: "rgba(255, 255, 255, 0.2)",
    grey30: "rgba(255, 255, 255, 0.3)",
    grey40: "rgba(255, 255, 255, 0.4)",
    grey50: "rgba(255, 255, 255, 0.5)",
    grey60: "rgba(255, 255, 255, 0.6)",
    grey70: "rgba(255, 255, 255, 0.7)",
    grey80: "rgba(255, 255, 255, 0.8)",
    grey100: "#FFFFFF",
    surfaceMinus1: "#0F0F0F",
    surface0: "#1A1A1A",
    surface1: "#2A2A2A",
    surfaceBlur: "rgba(42, 42, 42, 0.7)",
    surfaceStroke: "rgba(255, 255, 255, 0.1)",
    shadowColor: "rgba(0, 0, 0, 0.4)",
    primary: "#FFFFFF",
    onPrimary: "#000000",
    secondary: "rgba(238, 238, 238, 0.3)",
    onSecondary: "#FFFFFF",
    invert: "#FFFFFF",
    onInv100: "#1A1A1A",
    onInv80: "rgba(26, 26, 26, 0.8)",
    onInv60: "rgba(26, 26, 26, 0.6)",
    onInv40: "rgba(26, 26, 26, 0.4)",
    onInv20: "rgba(26, 26, 26, 0.2)",
    onInv10: "rgba(26, 26, 26, 0.1)",
    greenFill: "#57BE45",
    greenStroke: "rgba(87, 190, 69, 0.3)",
    greenText: "#81EA6F",
    yellowFill: "#C49D27",
    yellowStroke: "rgba(196, 157, 39, 0.3)",
    yellowText: "#FFD249",
    redFill: "#C94F4F",
    redStroke: "rgba(201, 79, 79, 0.3)",
    redText: "#FFA3A3",
    viz1: "#7F61F5",
    viz1Light: "#554498",
    viz2: "#C55C45",
    viz2Light: "#7F5B53",
    viz3: "#308F86",
    viz3Light: "#647776",
    viz4: "#BB9951",
    viz4Light: "#6A5E44",
    viz5: "#9B4459",
    viz5Light: "#7E6369",
    viz6: "#6D98B6",
    viz6Light: "#5A7A92",
    viz7: "#BA7747",
    viz7Light: "#816856",
    viz8: "#1984A4",
    viz8Light: "#306372",
    viz9: "#1A9459",
    viz9Light: "#4E7461",
    viz10: "#C09791",
    viz10Light: "#795B57",
    viz11: "#996AA5",
    viz11Light: "#6D5273",
    viz12: "#709693",
    viz12Light: "#49625F",
  },
} satisfies Record<string, ThemePalette>;

export type ThemeName = keyof typeof colors;
export const themeNames = Object.keys(colors) as ThemeName[];
